import { render } from "./PointsGuide.vue?vue&type=template&id=06c25d4a&scoped=true"
import script from "./PointsGuide.vue?vue&type=script&lang=js"
export * from "./PointsGuide.vue?vue&type=script&lang=js"

import "./PointsGuide.vue?vue&type=style&index=0&id=06c25d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c25d4a"]])

export default __exports__